// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__pbcuQ","selected":"Chip_selected__18Utv"};